import { useCallback, useRef, useState } from 'react';

import { WalletInventory, describeApiError, getWalletItems } from '../api/backend';

export const isValidAddress = (value: string): boolean => /^0x[a-fA-F0-9]{40}$/.test(value.trim());

export interface WalletData {
    inventory: WalletInventory | null;
    loading: boolean;
    error: string | null;
    search: (address: string) => void;
}

export const useWalletInventory = (): WalletData => {
    const [inventory, setInventory] = useState<WalletInventory | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const generation = useRef(0);

    const search = useCallback((address: string) => {
        const requestId = ++generation.current;
        setLoading(true);
        setError(null);
        getWalletItems(address.trim())
            .then((result) => {
                if (requestId !== generation.current) return;
                setInventory(result);
                setLoading(false);
            })
            .catch((requestError) => {
                if (requestId !== generation.current) return;
                setError(describeApiError(requestError));
                setLoading(false);
            });
    }, []);

    return { inventory, loading, error, search };
};
